<template>
  <div id="app" :style="style">
    <d-d-header></d-d-header>
    <router-view/>
    <d-d-footer></d-d-footer>
  </div>
</template>

<script>
import DDHeader from "components/dd_header/header";
import DDFooter from "components/dd_footer/footer";
export default {
  name: "App",
  data() {
    return {
      style: {}
    };
  },
  created() {
    this._isMobile()
  },
  components: {
    DDFooter,
    DDHeader
  },
  watch: {
    $route: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  methods: {
    _isMobile() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.style = { width: "1200px" };
      } else {
        this.style = { width: "100%" };
      }
    }
  }
};
</script>

<style>
#app {
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue